<template>
  <div>
    <SfModal
      :visible="open"
      title="Отзывы"
      class="modal"
      @close="$emit('close')"
    >
      <div>
        <SfHeading :level="3" title="Отзывы" class="navbar__title" style="margin-bottom: 30px;" />
        <template v-if="reviews.length > 0">
          <SfReview
            style="margin-bottom: 30px;"
            v-for="review in reviews"
            :key="review.id"
            :author="review.name"
            :message="review.comment || ''"
            :max-rating="5"
            :rating="review.rating"
            :char-limit="250"
            read-more-text="Расширить"
            hide-full-text="Сжать"
            class="product__review"
          />  
        </template>
        <div v-else class="empty" style="padding: 60px 30px; display: flex; align-items: center; justify-content: center;">
          Ничего не найдено
        </div>
      </div>
    </SfModal>
  </div>
</template>
<script>

import { SfModal, SfReview, SfHeading } from '@storefront-ui/vue';

export default {
  name: 'ReviewPopup',
  components: {
    SfModal,
    SfReview,
    SfHeading
  },

  props: {
    reviews: Array,
    open: Boolean
  },

  data() {
    return {
    }
  },
};
</script>

<style lang="scss">
.sf-modal {
  .sf-modal__close {
    display: flex !important;
  }  
}

.modal {
}

</style>